/*********************************************/
// whatsNew.js
// Modal-Komponente für "Was ist neu?" Feature
// Lädt komplettes Modal-HTML via AJAX/PHP
/*********************************************/

const SCRIPT_NAME = 'whatsNew.js';

// Locale aus <html lang="..."> Attribut lesen
const GET_USER_LOCALE = () => {
    return document.documentElement.lang || 'en-US'; // Fallback falls nicht gesetzt
};

const AJAX_URL = `/${GET_USER_LOCALE()}/assets/whatsNew/`;
const AJAX_MARK_READ_URL = `/${GET_USER_LOCALE()}/assets/whatsNew/ajax.markAsRead/`;

let isModalLoaded = false;
let unreadIds = [];

/**
 * Toggle-Funktion für das Modal
 * Lädt Modal beim ersten Aufruf via AJAX
 */
export async function toggleWhatsNewModal() {
    if (typeof window.bootstrap === 'undefined') {
        console.error(`${SCRIPT_NAME}: Bootstrap ist nicht verfügbar`);
        return;
    }

    // Modal beim ersten Aufruf laden
    if (!isModalLoaded) {
        await loadModalFromServer();
        isModalLoaded = true;
    }

    const modalElement = document.getElementById('whatsNewModal');
    if (!modalElement) {
        console.error(`${SCRIPT_NAME}: Modal-Element nicht gefunden`);
        return;
    }

    // Bootstrap Modal-Instanz holen oder erstellen
    const modalInstance = window.bootstrap.Modal.getOrCreateInstance(modalElement);
    modalInstance.toggle();

    window.utils?.consoleLog(SCRIPT_NAME, 'WhatsNew Modal getoggelt');
}

/**
 * Lädt das komplette Modal-HTML vom Server
 */
async function loadModalFromServer() {
    try {
        window.utils?.consoleLog(SCRIPT_NAME, `Lade Modal von: ${AJAX_URL}`);

        const response = await fetch(AJAX_URL, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const modalHTML = await response.text();

        // Modal-HTML in DOM einfügen
        const container = document.createElement('div');
        container.innerHTML = modalHTML.trim();
        const modalElement = container.firstChild;
        document.body.appendChild(modalElement);

        // Ungelesene IDs aus data-Attribut lesen
        const unreadIdsAttr = modalElement.dataset.unreadIds;

        if (unreadIdsAttr && unreadIdsAttr.trim() !== '') {
            try {
                const parsed = JSON.parse(unreadIdsAttr);

                if (Array.isArray(parsed)) {
                    unreadIds = parsed;
                    window.utils?.consoleLog(SCRIPT_NAME, `${unreadIds.length} ungelesene Beiträge gefunden`);
                } else {
                    console.error(`${SCRIPT_NAME}: Invalid unreadIds format - not an array`, parsed);
                    unreadIds = [];
                }
            } catch (e) {
                console.error(`${SCRIPT_NAME}: Invalid unreadIds format - JSON parse error:`, e);
                console.error(`${SCRIPT_NAME}: Raw attribute value:`, unreadIdsAttr);
                unreadIds = [];
            }
        } else {
            window.utils?.consoleLog(SCRIPT_NAME, 'Keine ungelesenen Beiträge (leeres data-Attribut)');
            unreadIds = [];
        }

        // Event-Listener für Modal-Close → Als gelesen markieren
        modalElement.addEventListener('hidden.bs.modal', markUnreadAsRead);

        window.utils?.consoleLog(SCRIPT_NAME, 'Modal erfolgreich geladen');

    } catch (error) {
        console.error(`${SCRIPT_NAME}: Fehler beim Laden des Modals`, error);
    }
}

/**
 * Markiert ungelesene Beiträge als gelesen (beim Modal-Close)
 */
async function markUnreadAsRead() {
    if (!unreadIds || unreadIds.length === 0) {
        window.utils?.consoleLog(SCRIPT_NAME, 'Keine ungelesenen Beiträge zu markieren');
        return;
    }

    try {
        const formData = new FormData();
        formData.append('unreadIds', JSON.stringify(unreadIds));

        const response = await fetch(AJAX_MARK_READ_URL, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success) {
            window.utils?.consoleLog(SCRIPT_NAME, `${data.markedCount} Beiträge als gelesen markiert`);

            // Badge-Counter im Header aktualisieren (falls vorhanden)
            updateBadgeCounter();

            // Für nächstes Öffnen zurücksetzen
            unreadIds = [];
        }

    } catch (error) {
        console.error(`${SCRIPT_NAME}: Fehler beim Markieren als gelesen`, error);
    }
}

/**
 * Aktualisiert den Badge-Counter im Header
 */
function updateBadgeCounter() {
    // Badge-Element im Header finden und ausblenden/aktualisieren
    const badge = document.querySelector('button[onclick*="whatsNew"] .badge');
    if (badge) {
        badge.remove();
    }

    // Icon von "Umschlag geschlossen" zu "Umschlag offen" ändern
    const icon = document.querySelector('button[onclick*="whatsNew"] i');
    if (icon && icon.classList.contains('fa-bell-ring')) {
        icon.classList.remove('fa-bell-ring');
        icon.classList.add('fa-bell');
    }
}